<template>
  <div class="d-flex justify-center flex-wrap gap mt-5 mb-5">
    <div class="row_inscription_bottom pa-1">
      <div>{{ error }}</div>
      <v-btn @click="inscrire_groupe" color="primary-dark" block class="sm-fullwidth mt-2 inscription_btn"
        variant="tonal" size="default"> <v-icon icon="mdi-arrow-right-bold"></v-icon> Inscrire un groupe </v-btn>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  data() {
    return {
      error: "",
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    inscrire_groupe() {
      this.error = "";
      if (this.mainStore.module.status == "avant_ouverture" && !this.mainStore.inscription_as_admin) {
        this.error = "Les inscriptions ne sont pas encore ouvertes";
        return;
      }
      if (this.mainStore.module.status == "apres_fermeture" && !this.mainStore.inscription_as_admin) {
        this.error = "Les inscriptions sont closes.";
        return;
      }
      if (this.mainStore.module.is_complet && !this.mainStore?.inscription_vip?.is_valid()) {
        this.error = "L'événement est complet.";
        return;
      }

      if (this.mainStore.module.allCoursesComplets && !this.mainStore?.inscription_vip?.is_valid()) {
        this.error = "L'événement est complet.";
        return;
      }


      this.mainStore.bookingSystem.is_inscription_groupe = true;
      this.$router.push({ name: "Inscriptions" });
    },
  },
};
</script>

<style lang="scss" scoped></style>